import { ChangeDetectorRef, Component, Inject, Optional, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CtDatatableConfiguration, CTDatatablePaginationParameter, CTGeneralService, CtSearchFiltersComponent, CtSearchFiltersConfiguration, DeleteConfirmService } from '@ctsolution/ct-framework';
import { TableColumn } from '@swimlane/ngx-datatable';
import { AddressBookListParameter } from 'src/app/core/classes/address-book-list.parameter';
import { JwtService } from 'src/app/core/lib/jwt.service';
import { ListService } from 'src/app/core/lib/list.service';
import { AddressBookService } from '../address-book.service';
import { AddressBookContactResponse } from 'src/app/core/interfaces/address-book-contact-response';
import { AddressBookContactController } from 'src/app/core/controllers/address-book-contact.controller';
import { AddressBookContactFilters, AddressBookContactParameter } from 'src/app/core/classes/address-book-contact.parameter';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef } from "@angular/material/legacy-dialog";

@Component({
  selector: 'app-address-book-contact',
  templateUrl: './address-book-contact.component.html',
  styleUrls: ['./address-book-contact.component.scss']
})
export class AddressBookContactComponent {

  @ViewChild("searchFilter") public searchFilter?: CtSearchFiltersComponent;
  @ViewChild("typeCellTemplate") public typeCellTemplate!: TemplateRef<any>;
  @ViewChild("nameCellTemplate") public nameCellTemplate!: TemplateRef<any>;



  addressBookContact!: CtDatatableConfiguration;
  filtersConfiguration: CtSearchFiltersConfiguration = CtSearchFiltersConfiguration
    .create()
    .setFilters(AddressBookContactFilters);

  private params: AddressBookListParameter = AddressBookListParameter.create();

  viewModel: {
    addressBookOid: number | null
    addressBookContactList: Array<AddressBookContactResponse>;
    title: string | null;
  } = { addressBookOid: null, addressBookContactList: [], title: null };

  constructor(
    private cdr: ChangeDetectorRef,
    private addressBookContactController: AddressBookContactController,
    private listService: ListService,
    private deleteConfirm: DeleteConfirmService,
    private general: CTGeneralService,
    private router: Router,
    private jwt: JwtService,
    private addressBookService: AddressBookService,
    private route: ActivatedRoute,
    @Optional() private matDialogRef: MatLegacyDialogRef<AddressBookContactComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: AddressBookContactParameter | null
  ) { }

  async ngOnInit(): Promise<void> {

    const addressBookEnabled = await this.jwt.getAddressBookEnabled()

    if (addressBookEnabled == false) {

      this.router.navigate(['/dashboard'])

    }

    this.route
      .queryParams
      .subscribe(async qp => {

        if (qp["Oid"]) {

          this.viewModel.addressBookOid = +qp["Oid"];

        }

        if (qp["Title"]) {

          this.viewModel.title = qp["Title"];

        }

        await this.setup()


      });

    if (this.viewModel.title) {

      this.route
        .data
        .subscribe(data => {

          data['title'] = `${data['title']}:  ${this.viewModel.title}`;
          this.cdr.detectChanges();

        })

    }

  }


  private async setup() {

    if (this.viewModel.addressBookOid) {
      this.viewModel.addressBookContactList = await this.getData(AddressBookContactParameter.create().setAddressBookOid(this.viewModel.addressBookOid));
      await this.setTable();
    } else if (this.data) {

      this.viewModel.addressBookContactList = await this.getData(AddressBookContactParameter.create().setAddressBookType(this.data.AddressBookType));
      await this.setTable();

    }

  }

  private async setTable() {

    const columns: TableColumn[] = [
      { prop: "Name", name: "Nominativo", sortable: false, cellTemplate: this.nameCellTemplate },
      { prop: "Address", name: "Indirizzo", sortable: false },
      { prop: "City", name: "Città", sortable: false },
      { prop: "ZipCode", name: "CAP", sortable: false },
      { prop: "Province", name: "Provincia", sortable: false },
      { prop: "Country", name: "Stato", sortable: false },
      { prop: "Email", name: "Email", sortable: false },
      { prop: "CertifiedEmail", name: "PEC", sortable: false },
      { prop: "Phone", name: "Telefono", sortable: false },
      { prop: "ContactCode", name: "Codice contatto", sortable: false },
      { prop: "GroupCode", name: "Codice gruppo", sortable: false }
    ];

    this.addressBookContact = CtDatatableConfiguration
      .create()
      .setScrollbarH(true)
      .setRowHeight(65)
      .setColumns(columns)
      .setController("AddressBookContact")
      .setCount(this.viewModel.addressBookContactList.length)
      .setEditingActionEnabled(this.data ? false : true)
      .setDeleteActionEnabled(this.data ? false : true)
      .setLimit(this.data ? 5 : 10)
      


          
    this.cdr.detectChanges();

  }

  private getData(param: AddressBookContactParameter) {

    return new Promise<Array<AddressBookContactResponse>>((resolve, reject) => {

      this.addressBookContactController
        .addressBookContactList(param)
        .subscribe({
          next: (response: any) => {

            const result = response.Result.Items ?? [];
            resolve(result);

          },
          error: (err) => {

            this.addressBookContact.setLoadingIndicator(false);
            reject(err);

          }
        });

    });

  }

  filter(event: any) {

    this.params = event ?? {};

    this.fetch();

  }

  fetch(pagination?: CTDatatablePaginationParameter) {

    this.addressBookContact.setLoadingIndicator(true);

    const paginatedData = this.listService.getFilteredDataAddressBook<AddressBookContactResponse>(this.viewModel.addressBookContactList, this.params, pagination);

    setTimeout(() => {

      this.addressBookContact
        .setRows(paginatedData)
        .setLoadingIndicator(false);

    }, 350);

  }

  async delete(addressBookContact: AddressBookContactParameter) {

    if (!addressBookContact.Oid || !addressBookContact.AddressBookOid) return;

    this.deleteConfirm
      .open()
      .afterClosed()
      .subscribe((result?: boolean) => {

        if (result) {

          this.addressBookContactController
            .delete(AddressBookContactParameter.create().setOid(addressBookContact.Oid).setAddressBookOid(addressBookContact.AddressBookOid))
            .subscribe(async () => {

              window.location.reload();

            });

        }

      });


  }

  create() {


    this.addressBookService.editContact(AddressBookContactParameter.create().setAddressBookOid(this.viewModel.addressBookOid)).afterClosed()
      .subscribe(async () => {

        this.viewModel.addressBookContactList = await this.getData(AddressBookContactParameter.create().setAddressBookOid(this.viewModel.addressBookOid));
        this.fetch()

      });

  }


  edit(addressBook: AddressBookContactParameter) {

    this.addressBookService.editContact(addressBook).afterClosed()
      .subscribe(async () => {

        this.viewModel.addressBookContactList = await this.getData(AddressBookContactParameter.create().setAddressBookOid(this.viewModel.addressBookOid));
        this.fetch()

      });

  }

  ngOnDestroy() {

    this.searchFilter?.reset();

  }

  selectContactByName(row: AddressBookContactResponse) {

    if (!this.matDialogRef) return;
    this.matDialogRef.close(row);

  }

  close() {

    if (!this.matDialogRef) return;
    this.matDialogRef.close(null);

  }

  back(){

    this.router.navigate(["/", "amministrazione", "rubrica"]);

  }

}
